import { FC, memo, ReactNode, useEffect, useLayoutEffect, useRef, useState } from "react"
import { Card } from "@square/web-payments-sdk-types"
import { BoxProps } from "../../components/layout"
import { useSquareCardContext } from "./SquareCardContext"
import { Skeleton } from "@material-ui/lab"
export interface SquareCardFormProps extends BoxProps {
	helperText?: string | ReactNode
	showSecuredByMessage?: boolean
	formState?: SquareCardFormState
	setFormState?: (formState: SquareCardFormState) => void
}

export type SquareCardFormState = "idle" | "submitted"

export const SquareCardForm: FC<SquareCardFormProps> = memo((props) => {
	const { makeCard, card } = useSquareCardContext()
	useEffect(() => {
		makeCard()
	}, [makeCard])
	if (!card) {
		return null
	}
	/**
	 * Russian-doll this so that we have a component that takes a non-nullish Card.
	 */
	return <SquareCardFormInternal card={card} {...props} />
})
const SquareCardFormInternal: FC<SquareCardFormProps & { card: Card }> = ({
	card,
	setFormState,
	formState,
}) => {
	const { clearCard } = useSquareCardContext()
	const cardRef = useRef<HTMLDivElement | null>(null)
	const [isAttached, setIsAttached] = useState(false)
	const [isLoading, setIsLoading] = useState(true)

	const handleRefresh = async (
		ref: HTMLDivElement,
		squareCard: Card,
		callback: (state: SquareCardFormState) => void
	) => {
		try {
			await squareCard.detach()
			setIsAttached(false)
			await squareCard.attach(ref)
			setIsAttached(true)
		} catch (e) {
			console.error(e)
		}
		callback("idle")
	}
	useEffect(() => {
		if (!isAttached && cardRef.current) {
			void card.attach(cardRef.current).then(() => {
				setIsAttached(true)
			})
		}
	}, [card])
	useEffect(() => {
		if (formState === "submitted" && isAttached && cardRef?.current && setFormState) {
			handleRefresh(cardRef.current, card, setFormState)
		}
	}, [formState])
	useEffect(() => {
		return () => {
			void clearCard()
		}
	}, [clearCard])
	useEffect(() => {
		if (isAttached && cardRef.current?.innerHTML?.length) {
			setIsLoading(false)
		} else {
			setIsLoading(true)
		}
	}, [isAttached, cardRef.current?.innerHTML?.length])
	return (
		<>
			<div ref={cardRef} />
			{isLoading && (
				<Skeleton
					variant="rect"
					height={48}
					width={"100%"}
					style={{ marginLeft: "-3.3rem", borderRadius: "0.5rem" }}
				/>
			)}
		</>
	)
}
